var _rect, _rect2, _path, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOthers = function SvgOthers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#7D8198"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.667,
    y: 11.667,
    width: 6.667,
    height: 6.667,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.56,
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 23.667a2 2 0 0 1 2-2h4.5a1 1 0 0 1 1 1v4.5a2 2 0 0 1-2 2h-3.5a2 2 0 0 1-2-2v-3.5ZM21.667 12.834a2 2 0 0 1 2-2h3.5a2 2 0 0 1 2 2v3.5a2 2 0 0 1-2 2h-4.5a1 1 0 0 1-1-1v-4.5Z",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.56,
    x: 21.667,
    y: 21.667,
    width: 6.667,
    height: 6.667,
    rx: 3.333,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgOthers;